import { render, staticRenderFns } from "./witnessStatusForm.vue?vue&type=template&id=462882bb&scoped=true"
import script from "./witnessStatusForm.vue?vue&type=script&lang=js"
export * from "./witnessStatusForm.vue?vue&type=script&lang=js"
import style0 from "./witnessStatusForm.vue?vue&type=style&index=0&id=462882bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462882bb",
  null
  
)

export default component.exports